import React , { useState } from "react";
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';

//CSS
import styles from  "./footer.module.less";

//ICONS
import imgSubvencion from "assets/img/layout/footer/footer_subvencion.webp";

function Footer() {

  const [t, i18n] = useTranslation("layout");
  const year = new Date().getFullYear();
  const [mailtext, setMailText]= useState(t('footer.Haz clic para ver el e-mail'));

  return (
    <footer className={styles.footer}>

      <div className={styles.divider}></div>

      <div className={styles.content}>
        <div>
          <h2>{t('footer.Donde estamos')}</h2>
            <ul>
              <li>Viajes Teide</li>
              <li>Avn. V Centenario, 2 Local 5</li>
              <li>Las Americas, 38670 - Adeje</li>
              <li>Santa Cruz de Tenerife</li>
              <li>&nbsp;</li>
            </ul>
        </div>

        <div>
          <h2>{t('footer.Conócenos')}</h2>
          <ul>
            <li><Link to={"/" + i18n.language + "/company"}>{t('footer.Empresa')}</Link></li>
            <li><Link to={"/" + i18n.language + "/blog"}>{t('footer.El Blog')}</Link></li>
            <li><Link to={"/" + i18n.language + "/faq"}>{t('footer.FAQ')}</Link></li>
            <li><Link to={"/" + i18n.language + "/legal-terms"}>{t('footer.Avíso Legal')}</Link></li>
            <li><Link to={"/" + i18n.language + "/transparencia"}>{t('footer.Portal de transparencia')}</Link></li>
          </ul>
        </div>

        <div>
          <h2>{t('footer.Contacto')}</h2>
          <ul>
            <li>{t('footer.Telefono')}: +34 922 795 864</li>
            <li>{t('footer.Fax')}: +34 922 796 652</li>
            <li><span className={styles.mailText} onClick={()=>setMailText(atob("aW5mb0B2aWFqZXN0ZWlkZS5lcw=="))}>{mailtext}</span></li>
          </ul>
        </div>
      </div>

      <div className={styles.services}>
        <div>
          <ul>
              <li><i className={styles.iconSecure}></i></li>
              <li><b>{t('footer.La conexión y pagos son seguros')}</b></li>
              <li><i className={styles.iconCards}></i></li>
          </ul>
        </div>

        <div>
          <ul>
            <li><i className={styles.iconPhone}></i></li>
            <li><b>{t('footer.Atención al cliente personalizado')}</b></li>
            <li>{t('footer.Todos los días de 0700h a 2000h')}</li>
          </ul>
        </div>

        <div>
          <ul>
            <li><i className={styles.iconViajesteide}></i></li>
            <li><b>{t('footer.Profesionalidad y experiencia')}</b></li>
            <li>{t('footer.más de 30 años trabajando en el sector')}</li>
          </ul>
        </div>
      </div>

      <div className={styles.social} >
        <div className={styles.socialContent} >
          <div>
            <a href="https://www.facebook.com/viajes.teide" target="_blank" rel="noreferrer">
              <i className={styles.iconFacebook}></i>
              <br />
              /viajes.teide
            </a>
          </div>
          <div>
            <a href="https://twitter.com/ViajesTeide" target="_blank" rel="noreferrer">
              <i className={styles.iconTwiter}></i>
              <br />
              @viajesteide
            </a><
            /div>
          <div>
            <a href="https://www.instagram.com/viajesteide/" target="_blank" rel="noreferrer">
              <i className={styles.iconInstagram}></i>
              <br />
              @viajesteide
            </a>
          </div>
        </div>
      </div>

      <div className={styles.avanza}>
        <img src={imgSubvencion} alt="logo canarias avanaza"/>
        <div>
          <a href={'https://www.biospheresustainable.com/' + i18n.language + '/community/viajes-teide/62'} target="_blank" title="Viajes Teide" rel="noreferrer">
            <img src="https://www.biospheresustainable.com/plugin/award/62?key=d135edcabe02a7f34758585af912c56b&size=70&style=1" alt="Acredita&ccedil;&atilde;o da distin&ccedil;&atilde;o Biosphere"/>
          </a>
        </div>
      </div>

      <div className={styles.copyright}>
        Viajes Teide &copy; 2015 - {year} {t('footer.Todos los derechos reservados')}. I-AV-0000028.11
      </div>

    </footer>

  );
}

export default Footer;
